import { render } from "./BannerEclipse.vue?vue&type=template&id=5ef25afa&scoped=true"
import script from "./BannerEclipse.vue?vue&type=script&lang=js"
export * from "./BannerEclipse.vue?vue&type=script&lang=js"

import "./BannerEclipse.vue?vue&type=style&index=0&id=5ef25afa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef25afa"]])

export default __exports__